var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { DayPicker } from "react-day-picker";
import enUS from "date-fns/locale/en-US";
import Button from "../../Button/Button";
import Picker from "../Picker";
var RangePicker = function (_a) {
    var _b, _c;
    var title = _a.title, cancelText = _a.cancelText, continueText = _a.continueText, show = _a.show, setShow = _a.setShow, onSelect = _a.onSelect, defaultSelected = _a.defaultSelected, rangePresets = _a.rangePresets, fromDate = _a.fromDate, toDate = _a.toDate, withTime = _a.withTime;
    var _d = useState(defaultSelected), range = _d[0], setRange = _d[1];
    var _e = useState((withTime === null || withTime === void 0 ? void 0 : withTime.initialHour) || ((_b = defaultSelected.from) === null || _b === void 0 ? void 0 : _b.getHours()) || 0), hour = _e[0], setHour = _e[1];
    var _f = useState((withTime === null || withTime === void 0 ? void 0 : withTime.initialMinute) || ((_c = defaultSelected.from) === null || _c === void 0 ? void 0 : _c.getMinutes()) || 0), minute = _f[0], setMinute = _f[1];
    return (_jsx(Picker, __assign({ title: title, cancelText: cancelText, continueText: continueText, show: show, setShow: setShow, onContinue: function () {
            var _a, _b;
            if (withTime) {
                (_a = range === null || range === void 0 ? void 0 : range.from) === null || _a === void 0 ? void 0 : _a.setHours(hour, minute, 0, 0);
                (_b = range === null || range === void 0 ? void 0 : range.to) === null || _b === void 0 ? void 0 : _b.setHours(hour, minute, 0, 0);
            }
            onSelect(range);
            setShow(false);
        }, withTime: withTime, setHour: setHour, hour: hour, setMinute: setMinute, minute: minute }, { children: _jsxs("div", __assign({ className: "flex gap-6 mt-6 mb-3 flex-col sm:flex-row" }, { children: [rangePresets &&
                    _jsx("div", __assign({ className: "flex flex-col gap-2 shrink-0" }, { children: rangePresets.map(function (_a, i) {
                            var range = _a.range, name = _a.name, _b = _a.disabled, disabled = _b === void 0 ? false : _b, icon = _a.icon;
                            return (_jsx(Button, { type: "white", text: name, disabled: disabled, icon: icon, onClick: function () {
                                    setRange(range);
                                    onSelect(range, name);
                                    setShow(false);
                                } }, i));
                        }) })), _jsx(DayPicker, { showOutsideDays: true, showWeekNumber: true, locale: enUS, weekStartsOn: 0, mode: "range", selected: range, defaultMonth: range === null || range === void 0 ? void 0 : range.from, onSelect: setRange, fromDate: fromDate, toDate: toDate })] })) })));
};
export default RangePicker;
